import { render, staticRenderFns } from "./InstalarPantalla.vue?vue&type=template&id=1828c20e"
import script from "./InstalarPantalla.vue?vue&type=script&lang=js"
export * from "./InstalarPantalla.vue?vue&type=script&lang=js"
import style0 from "./InstalarPantalla.vue?vue&type=style&index=0&id=1828c20e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports